// extracted by mini-css-extract-plugin
export default {"container":"UV3Ep2A7VuZIo2G8KmSg","code":"oMpPDfyTxqwl8LDaURtT","title":"Wg5DO4QcOT4NplGzPgoQ"};